
import * as __star__ from 'fuzzy';

const {
default: __default__,
simpleFilter,
test,
match,
filter
} = __star__;

export {
simpleFilter,
test,
match,
filter
};
export default __default__;
